let activeChannel = ''
const CHANNEL_SESSION_KEY = 'bingotraditional-active-channel-v1'

function sessionChannel () {
  try {
    return window.sessionStorage.getItem(CHANNEL_SESSION_KEY) || ''
  } catch (error) {
    return ''
  }
}

function rememberChannel (channel) {
  if (!channel) return
  try {
    window.sessionStorage.setItem(CHANNEL_SESSION_KEY, channel)
  } catch (error) {}
}

function queryChannel () {
  const search = new URLSearchParams(window.location.search)
  if (search.get('channel')) return search.get('channel')
  const hashQuery = String(window.location.hash || '').split('?')[1] || ''
  return new URLSearchParams(hashQuery).get('channel') || ''
}

export function initializeChannelContext () {
  activeChannel = queryChannel() || sessionChannel()
  rememberChannel(activeChannel)
  if (activeChannel === 'aigc_hn') {
    document.documentElement.classList.add('channel-aigc-hn')
    document.title = '人工智能课堂'
    const favicon = document.querySelector('link[rel="icon"]')
    if (favicon) favicon.href = 'data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 64 64%22%3E%3Crect width=%2264%22 height=%2264%22 rx=%2214%22 fill=%22%23269ed8%22/%3E%3Ctext x=%2232%22 y=%2241%22 text-anchor=%22middle%22 font-size=%2228%22 font-family=%22Arial%22 font-weight=%22700%22 fill=%22white%22%3EAI%3C/text%3E%3C/svg%3E'
  }
  return activeChannel
}

export function currentChannel () {
  const channel = activeChannel || queryChannel() || sessionChannel()
  if (channel && channel !== activeChannel) {
    activeChannel = channel
    rememberChannel(channel)
  }
  return channel
}

export function isAigcHn () {
  return currentChannel() === 'aigc_hn'
}
